export const values = {
  CannotPlaceBuyOrders: 'CannotPlaceBuyOrders',
  CannotPlaceSellOrders: 'CannotPlaceSellOrders',
  CannotUsePsp: 'CannotUsePsp',
}
